import { schema } from "normalizr";
/**
 * Defines the shape of the outcome object from the ContentAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const outcome = new schema.Entity("outcomes", {});

/**
 * Defines the shape of the market object from the ContentAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const market = new schema.Entity("markets", {
  outcomes: [outcome]
});

/**
 * Defines the shape of the event object from the ContentAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const event = new schema.Entity("events", {
  markets: [market]
});

/**
 * Defines the shape of the ContentAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
export const contentApiSchema = {
  events: [event]
};



// WEBPACK FOOTER //
// ./src/apis/content/contentApiSchema.js